import './../css/LeftColumn.css';
import CrmGroupList from "./CrmGroupList";

function CrmLeftColumn() {

    return (
        <div className="LeftColumn">
            <CrmGroupList />
        </div>

    );
}

export default CrmLeftColumn;

